import React from 'react';
import Slider from 'react-slick';

import settings from './SlickSettings';
import { happyClient } from './data';

const Settings = {
  ...settings,
  autoplay: true,
  autoplaySpeed: 7000,
};

const HappyClient = () => (
  <section className="section section--white section--spacer section--hexagon-bg">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h2 className="text-uppercase text-center section-header">Happy Travelers</h2>
          {/* <p className="font-weight-normal text-center">
            Pick your own Lodge. Pick your own Guide. Just book Flights if you want. It is
            your trek afterall. We believe you should be the one calling the shots.
          </p> */}
          <hr className="hr--small mb-4" />

          <div id="slick-valued-trekkers" className="slick-valued-trekkers">
            <Slider {...Settings}>
              {happyClient.map(({ name, img, desc, title }) => (
                <div className="slick-valued-trekkers-slide" key={name}>
                  <div className="slick-valued-trekkers-slide-content">
                    <div className="happy" key={name}>
                      <div className="happy-client">
                        <div className="happy-client-image hexagon-wrapper">
                          <div className="hexagon">
                            <div
                              className="hexagon-background"
                              style={{
                                backgroundImage: `url(${img})`,
                              }}
                            />
                          </div>
                        </div>
                        <div className="happy-client-detail">
                          <h5>{name}</h5>
                          {/* <p>{title}</p> */}
                        </div>
                      </div>
                      <div className="happy-client-message">
                        <p className="quote mt-4">{desc}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HappyClient;



// WEBPACK FOOTER //
// ./src/screens/Landing/HappyClient.jsx